import { Box, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { round } from '@kheops/utils';
import LoadingDots from '../common/components/LoadingDots';
import useCurrencyFormat from '../hooks/useCurrencyFormat';
import MinimumOrderValueChip from '../common/components/MinimumOrderValueChip';
import { BasketOrder } from '../hooks/useBasketOrders';
import { isBasketLoadingAtom } from './state/state';

export interface BasketOrderPriceProps {
  basketOrder: BasketOrder;
}

export function BasketOrderPrice({ basketOrder }: BasketOrderPriceProps): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const currencyFormat = useCurrencyFormat();
  const isBasketLoading = useAtomValue(isBasketLoadingAtom);
  const { items, totalPrice, minimumOrderValueProgression } = basketOrder;

  const minimumOrderValue = items[0].contract.minimum_order_value!;
  const minimumOrderValueType = items[0].contract.minimum_order_value_type;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="bodySmall">
        {t('common:total')} :
      </Typography>
      <LoadingDots loading={isBasketLoading}>
        <Typography variant="bodySmall">
          &nbsp;{currencyFormat.format(round(totalPrice))}
        </Typography>
      </LoadingDots>
      <MinimumOrderValueChip
        minimumOrderValue={minimumOrderValue}
        minimumOrderValueType={minimumOrderValueType}
        minimumOrderValueProgression={minimumOrderValueProgression}
        enableProgress
        sx={{ ml: 1 }}
      />
    </Box>
  );
}
